import React from "react"
import "./Navbar.css"
import { Link } from "gatsby"
const Navbar = props => {
  return (
    <nav className={`navbar ${props.navOpen ? "open" : "close"}`}>
      <Link className={"span"} to="/">
        Home
      </Link>
      <Link className={"span"} to="/gallery/">
        Gallery
      </Link>
      <Link className={"span"} to="/contact/">
        Contact
      </Link>
    </nav>
  )
}
export default Navbar
